import { DeliveryType } from '@libs/core';

export type Quantity = {
    label: string;
    value: string;
};

const getAvailableQuantities = (minQty = 1, stock = 0, maxDisplayQty = 500) => {
    const availableQuantities: Quantity[] = [];

    if (stock === 0 || minQty > stock) {
        return availableQuantities;
    }

    const qty = minQty < 1 ? 1 : minQty;

    for (let i = qty; i <= stock && i <= maxDisplayQty; i += qty) {
        availableQuantities.push({
            label: i.toString(),
            value: i.toString(),
        });
    }

    return availableQuantities;
};

const getDefaultSelectedInventory = (
    bopisDisabled: boolean,
    sddDisabled: boolean,
    isAutoshipSupported: boolean,
    isShipToHomeSupported: boolean
) => {
    if (bopisDisabled && isShipToHomeSupported) {
        return DeliveryType.STM;
    }
    if (bopisDisabled && !isShipToHomeSupported && isAutoshipSupported) {
        return DeliveryType.AUTOSHIP;
    }
    if (
        bopisDisabled &&
        !isShipToHomeSupported &&
        !isAutoshipSupported &&
        !sddDisabled
    ) {
        return DeliveryType.SDD;
    }

    return DeliveryType.BOPIS;
};

export { getAvailableQuantities, getDefaultSelectedInventory };
